module.exports = __webpack_public_path__ + "static/media/ARMAN-AI-01.506fd1dd.svg";